export const configTrainingAirspaceHighDh = {
  "data": {
    "Type": "GeoJSON",
    "url": "pri/data/Aerial/aip5-2-high.json",
    "update_interval": 0,
    "retain": true,
    "cache": true,
  }
}

export const configTrainingAirspaceLowDh = {
  "data": {
    "Type": "GeoJSON",
    "url": "pri/data/Aerial/aip5-2-low.json",
    "update_interval": 0,
    "retain": true,
    "cache": true,
  }
}

export const configTrainingAirspaceCivilDh = {
  "data": {
    "Type": "GeoJSON",
    "url": "pri/data/Aerial/aip5-3.json",
    "update_interval": 0,
    "retain": true,
    "cache": true,
  }
}

export const configTrainingAirspaceADIZDh = {
  "data": {
    "Type": "GeoJSON",
    "url": "pri/data/Aerial/adiz.json",
    "update_interval": 0,
    "retain": true,
    "cache": true,
  }
}

export const configTrainingAirspaceLayer = {
  "Name": "TrainingAirspace",
  "Renderer": "GeoJSONExt",
  "Attributes": {
    "features": [{
      "style": {
        "default": {
          "type": "polygon",
          "line_color": "#fd7e00",
          "_fill_color": "rgba(0,0,0,0)",
          "fill_color": "rgba(253,126,0,0.03)",
          "line_width": 2,
        },
        "civil": {
          "type": "polygon",
          "line_color": "#008000",
          "_fill_color": "rgba(0,0,0,0)",
          "fill_color": "rgba(0,128,0,0.03)",
          "line_width": 2,
        },
        "adiz": {
          "type": "polygon",
          "line_color": "#bc002d",
          "fill_color": "rgba(188,0,45,0.03)",
          "line_width": 2,
        }
      }
    }]
  }
}